var map = {
	"./black/shape_1_02.png": "8b10",
	"./black/shape_1_05.png": "4de6",
	"./black/shape_1_06.png": "4bb5",
	"./black/shape_1_08.png": "0b30",
	"./black/shape_1_09.png": "3d4c",
	"./black/shape_1_10.png": "a5e2",
	"./black/shape_1_11.png": "f2e0",
	"./black/shape_1_13.png": "1b8e",
	"./black/shape_1_14.png": "b40f",
	"./black/shape_1_15.png": "2572",
	"./black/shape_1_16.png": "cbd4",
	"./black/shape_1_20.png": "99c7",
	"./black/shape_1_24.png": "e020",
	"./blue/shape_1_02.png": "5132",
	"./blue/shape_1_05.png": "d048",
	"./blue/shape_1_06.png": "2d5d",
	"./blue/shape_1_08.png": "149a",
	"./blue/shape_1_09.png": "1e9e",
	"./blue/shape_1_10.png": "599b",
	"./blue/shape_1_11.png": "756c",
	"./blue/shape_1_13.png": "8fb1",
	"./blue/shape_1_14.png": "74db",
	"./blue/shape_1_15.png": "8ea4",
	"./blue/shape_1_16.png": "1e57",
	"./blue/shape_1_20.png": "7acd",
	"./blue/shape_1_24.png": "c0a1",
	"./logo.png": "ede7",
	"./onetwo.png": "b941",
	"./shape_1_02.png": "10d3",
	"./shape_1_05.png": "3e42",
	"./shape_1_06.png": "4ba7",
	"./shape_1_08.png": "1d58",
	"./shape_1_09.png": "6c55",
	"./shape_1_10.png": "6ead",
	"./shape_1_11.png": "9b4b",
	"./shape_1_13.png": "adb9",
	"./shape_1_14.png": "98f6",
	"./shape_1_15.png": "07d8",
	"./shape_1_16.png": "5a3d",
	"./shape_1_20.png": "55f5",
	"./shape_1_24.png": "aced"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33db";